import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faEyeSlash} from '@fortawesome/pro-solid-svg-icons';
import {canToggleAssetVisibility, assetIsVisible} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionNotVisibleIcon = faEyeSlash;

/**
 * Make asset not visible
 * @param params
 * @returns Action
 */
export const assetActionMakeNotVisible = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-not-visible',
	cb: () => dispatcher.trigger(ASSET_EVENT.MAKE_NOT_VISIBLE, asset),
	enableTest: () => canToggleAssetVisibility(asset) && assetIsVisible(asset),
	icon: assetActionNotVisibleIcon,
	get label() {
		return AssetActionLabel.MAKE_NOT_VISIBLE;
	},
	...params,
});
